<template>
    <div class="modal-overlay" v-if="show">
        <div class="modal-box">
            <h3 class="modal-title">Confirmação de Senha</h3>
            <p class="modal-message">Será necessário confirmar a sua senha para prosseguir com a ação</p>

            <input
                type="password"
                v-model="senha"
                class="modal-input input-center"
                :class="{'input-error': erro !== ''}"
                @keyup.enter="confirmar"
            />

            <p v-if="erro" class="error-message">{{ erro }}</p>

            <div class="row">
                <button class="btn-cancel" @click="cancelar">Cancelar</button>
                <button class="btn-confirm" @click="confirmar">Confirmar</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const show = ref(false);
const senha = ref('');
const erro = ref('');
let resolver;

function showModal() {
    senha.value = '';
    erro.value = '';
    show.value = true;
    return new Promise(resolve => {
        resolver = resolve;
    });
}

function confirmar() {
    if (!senha.value || senha.value.trim().length < 4) {
        erro.value = 'Informe uma senha válida (mínimo 4 caracteres)';
        return;
    }
    erro.value = '';
    show.value = false;
    resolver(senha.value);
}

function cancelar() {
    erro.value = '';
    show.value = false;
    resolver(null);
}

defineExpose({ showModal });
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex; align-items: center; justify-content: center;
    z-index: 9999;
}

.modal-box {
    background: white;
    padding: 24px;
    border-radius: 10px;
    width: 350px;
    box-shadow: 0 0 10px #0003;
}

.modal-title {
    margin: 0 0 10px;
    font-size: 18px;
    font-weight: bold;
}

.modal-message {
    margin-bottom: 15px;
    font-size: 14px;
}

.modal-input {
    width: 100%;
    padding: 8px;
    margin-bottom: 12px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.modal-input.input-error {
    border-color: red;
}

.error-message {
    color: red;
    font-size: 13px;
    margin: 0 0 12px;
}
</style>
